module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      F. Paul Wilson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("F. Paul Wilson is the author of more than fifty books spanning various genres, including science fiction, horror, thriller, and more. Four of his novels have been "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestsellers, and his work has earned him four Prometheus Awards, the prestigious Inkpot Award from the San Diego Comic-Con, and the Pioneer Award from the RT Booklovers Convention.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7LOZKT/tc-custom/9781504051675.jpg?1703427430319",
      "alt": "This image is the cover for the book Deep as the Marrow"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Deep as the Marrow\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of "), _c('i', [_vm._v("The Select")]), _vm._v(" “combines medical and political intrigue into one explosive, warp-speed thriller” (Douglas Preston).")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" To end the war on drugs, the president of the United States decides to legalize narcotics—and tax them heavily. Some think he’s crazy. Others want him dead."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The president’s personal physician, John Van Duyne, took an oath to do no harm, but after a Colombian drug lord kidnaps his six-year-old daughter, he’s forced to do the unthinkable to save her: poison the president.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    MysteriousPress.com/Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0